import { Pipe, PipeTransform } from '@angular/core';
import { Location } from '@angular/common';
import { UrlService } from '../../services/url/url.service';

@Pipe({
  name: 'emailLink',
})
export class EmailLinkPipe implements PipeTransform {
  constructor(private _urlService: UrlService) {}

  transform(email: string, subject?: string, body?: string): string {
    let queryUrl = '';

    if (subject || body) {
      const queryParams = {
        ...(subject ? { subject } : {}),
        ...(body ? { body } : {}),
      };

      queryUrl = Location.normalizeQueryParams(
        this._urlService.serializeParams(queryParams)
      );
    }

    return `mailto:${email.replace(/\s+/g, '')}${queryUrl}`;
  }
}
